// src/utils/uploadToFirebase.js
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../firebaseconfig";

/**
 * Upload file to Firebase with progress tracking
 * @param {File} file - File to upload
 * @param {string} path - Folder path in Firebase Storage
 * @param {function} onProgress - Callback function to handle upload progress (0–100)
 * @returns {Promise<string>} Download URL of uploaded file
 */
export const uploadFileToFirebase = (file, folder, onProgress) => {
  return new Promise((resolve, reject) => {
    const storageRef = ref(storage, `${folder}/${Date.now()}_${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        if (onProgress) onProgress(progress);
      },
      (error) => reject(error),
      async () => {
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
        resolve(downloadURL); // ✅ make sure to resolve after complete
      }
    );
  });
};
